import { Grid, makeStyles, Theme } from "@material-ui/core";
import React, { FunctionComponent, useContext, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { FeedbackType, useResilienceLazyQuery } from "../../../../api/smartmelts-api/graphql/generated";
import { ContentText } from "../../../../components/text/content-text";
import { HeadingText } from "../../../../components/text/heading-text";
import { AnswerContext } from "../../answer/context/answer-context";
import { NutritionContext } from "../../context/nutrition-context";
import { QuestionSectionLoadingIndicator } from "../../question/question-section-loading-indicator";
import { ResilienceResults } from "./resilience-results";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    flex: 1,
    width: "100%",
  },
  indicatorContainer: {
    width: "100%",
  },
  emptyContainer: {
    marginTop: theme.spacing(10),
    marginBottom: theme.spacing(6),
  },
  contentText: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
  },
}));

interface IResilienceAnswerProps {}

export const ResilienceAnswer: FunctionComponent<IResilienceAnswerProps> = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const { activeAnswer } = useContext(AnswerContext);
  const { isDemo, scrollTop } = useContext(NutritionContext);

  const [resilienceQuery, { loading, data }] = useResilienceLazyQuery({
    variables: { demo: isDemo },
    onCompleted: () => {
      scrollTop();
    },
  });
  const resilience = useMemo(() => data?.resilience, [data]);

  useEffect(() => {
    if (activeAnswer) {
      resilienceQuery({ variables: { demo: isDemo } });
    }
  }, [resilienceQuery, activeAnswer, isDemo]);

  return (
    <Grid container className={classes.container}>
      <HeadingText>{t(`twin_communication.answer.${FeedbackType.RESILIENCE}.heading`)}</HeadingText>
      <Grid item className={classes.contentText}>
        <ContentText light>{t(`twin_communication.answer.${FeedbackType.RESILIENCE}.description_1`)}</ContentText>
        <br />
        <ContentText light small>
          {t(`twin_communication.answer.${FeedbackType.RESILIENCE}.description_2`)}
        </ContentText>
      </Grid>
      <Grid container direction="column" spacing={4}>
        {!loading && resilience && <ResilienceResults resilience={resilience} />}
        {loading && <QuestionSectionLoadingIndicator />}
      </Grid>
    </Grid>
  );
};
